import { LS_KEY_AFTER_LOGIN_PATH } from "@/config/localStorageKeys";
import { auth } from "@/libs/firebase";
import { CircularProgress, Container, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useRouter } from "next/router";
import type React from "react";
import { useEffect } from "react";
import { useAuthState } from "react-firebase-hooks/auth";

declare global {
	interface Window {
		fcWidget?: {
			isInitialized: () => boolean;
			isOpen: () => boolean;
			open: () => void;
			destroy: () => void;
			init: (arg: {
				token: string;
				host: string;
				tags: string[];
				externalId: string;
				config: {
					headerProperty: {
						hideChatButton: boolean;
					};
				};
			}) => void;
		};
	}
}

export const PrivateContent: React.FC<{
	children: React.ReactNode;
	afterLoginPath?: string;
}> = ({ children, afterLoginPath }) => {
	const router = useRouter();
	const [user, loading, error] = useAuthState(auth);

	useEffect(() => {
		if (loading) return;

		if (!user?.uid) {
			afterLoginPath &&
				window.localStorage.setItem(LS_KEY_AFTER_LOGIN_PATH, afterLoginPath);
			router.replace("/signin-with-email");
		}
	}, [afterLoginPath, loading, router, user?.uid]);

	if (error) {
		return (
			<Container component="main" maxWidth="xs">
				<Box
					height={"300px"}
					display="flex"
					justifyContent="center"
					alignItems="center"
				>
					<Typography>エラーが発生しました</Typography>
				</Box>
			</Container>
		);
	}

	if (user && !loading) {
		return <>{children}</>;
	}

	return (
		<Container component="main" maxWidth="xs">
			<Box
				height={"300px"}
				display="flex"
				justifyContent="center"
				alignItems="center"
			>
				<CircularProgress color="primary" />
			</Box>
		</Container>
	);
};
